import { useMemo } from 'react';
import useSWR from 'swr';
import { useApi } from '../provider/useApi';

export function useSysKeyNames(grp: string) {
  const api = useApi();
  const {
    data: keyList,
    error,
    isLoading,
  } = useSWR(
    `/p/api/sys-key/keys-by-grp/${grp}`,
    () => api.sysKey.keysByGrp({ grp }).then((it) => it.keyList),
    {
      refreshInterval: 0,
    },
  );

  const records = useMemo(
    () =>
      keyList
        ? keyList.reduce(
            (acc, cur) => {
              acc[cur.key] = cur.keyName;
              return acc;
            },
            {} as Record<string, string>,
          )
        : undefined,
    [keyList],
  );

  return {
    data: records,
    isLoading,
    isError: error,
  };
}
